export const SET_PROMPTS = 'SET_PROMPTS';
export const SET_SYSTEM_PROMPTS = 'SET_SYSTEM_PROMPTS';
